var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 14.0822 20.278 16.1 18.9571 17.7095C17.6362 19.3191 15.798 20.4208 13.7558 20.8271C11.7136 21.2333 9.59376 20.9188 7.75743 19.9373C5.9211 18.9557 4.48191 17.3679 3.68508 15.4442C2.88826 13.5205 2.78311 11.38 3.38754 9.38744C3.99197 7.3949 5.26858 5.67358 6.99987 4.51677C8.73115 3.35997 10.81 2.83925 12.8822 3.04334C14.6211 3.21461 16.2651 3.88746 17.619 4.9696C18.0505 5.31441 18.0474 5.95262 17.6569 6.34315L13.35 10.65",
    stroke: "#42526E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8185 8.18162C14.9351 7.29822 13.7727 6.74846 12.5294 6.626C11.2861 6.50355 10.0388 6.81598 9.00002 7.51006C7.96125 8.20415 7.19528 9.23694 6.83262 10.4325C6.46996 11.628 6.53305 12.9123 7.01115 14.0665C7.48924 15.2207 8.35275 16.1734 9.45456 16.7624C10.5564 17.3513 11.8283 17.54 13.0536 17.2962C14.2789 17.0525 15.3818 16.3915 16.1744 15.4257C16.9669 14.46 17.4001 13.2493 17.4001 12",
    stroke: "#42526E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1764 10.65C12.5908 10.6908 12.9783 10.8741 13.2727 11.1685C13.6678 11.6024 13.7758 11.8796 13.8 12.4413C13.8 12.8578 13.6556 13.2613 13.3914 13.5832C13.1272 13.9052 12.7596 14.1255 12.3511 14.2067C11.9427 14.288 11.5187 14.2251 11.1514 14.0288C10.7842 13.8325 10.4963 13.5149 10.337 13.1302C10.1776 12.7454 10.1566 12.3173 10.2775 11.9188C10.3983 11.5203 10.6537 11.176 10.9999 10.9447C11.3462 10.7133 11.7619 10.6092 12.1764 10.65Z",
    stroke: "#42526E",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar);
export default __webpack_public_path__ + "static/media/radar.5e6a020fe836fd50d2a6f5ef27d2ce02.svg";
export { ForwardRef as ReactComponent };